import React, { useRef } from "react";
import {
  Box,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import { toThreeDecimals } from "../../../components/NewDetail/calculations/utils";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const PrintWeeklyTimeSummariesButton = ({
  start,
  weeklyUserTimeSummaries,
  ...props
}) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  if (start && weeklyUserTimeSummaries)
    return (
      <>
        <Fab
          variant="extended"
          color="success"
          onClick={() => {
            handlePrint();
          }}
        >
          <PrintIcon sx={{ marginRight: "8px" }} />
          Print Summaries
        </Fab>
        <div style={{ display: "none" }}>
          <div ref={componentRef}>
            <div
              style={{
                margin: "32px",
                backgroundColor: "#fff",
                color: "#000",
                position: "relative",
                breakInside: "avoid",
                breakBefore: "always",
                breakAfter: "always",
              }}
            >
              <Typography variant="h4" textAlign="center">
                Weekly Hours
              </Typography>
              <Typography variant="h5" textAlign="center">
                {start
                  .tz(DEFAULT_TIMEZONE)
                  .startOf("isoWeek")
                  .format("MM/DD/YYYY")}{" "}
                -{" "}
                {start
                  .tz(DEFAULT_TIMEZONE)
                  .endOf("isoWeek")
                  .format("MM/DD/YYYY")}
              </Typography>
              <Box>
                <Box sx={{ marginTop: "16px" }}>
                  <TableContainer component={Box}>
                    <Table sx={{}}>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Employee</TableCell>
                          <TableCell align="left">Week Total Hours</TableCell>
                          <TableCell align="left">No-Work Days</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {weeklyUserTimeSummaries &&
                          weeklyUserTimeSummaries.map(
                            (weeklyUserTimeSummary, index) => {
                              return (
                                <TableRow key={weeklyUserTimeSummary.id}>
                                  <TableCell align="left">
                                    <Box
                                      sx={{
                                        width: "400px",
                                        textTransform: "uppercase",
                                        fontWeight: "bold",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "-webkit-box",
                                        WebkitLineClamp: "1",
                                        WebkitBoxOrient: "vertical",
                                      }}
                                    >
                                      {weeklyUserTimeSummary.user.fullName}
                                    </Box>
                                  </TableCell>
                                  <TableCell align="left">
                                    {toThreeDecimals(
                                      Number(
                                        weeklyUserTimeSummary.totalWorkMinutes ??
                                          0,
                                      ) / 60,
                                    )}
                                  </TableCell>
                                  <TableCell align="left">
                                    {Number(
                                      weeklyUserTimeSummary.totalNoWorkDays ??
                                        0,
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            },
                          )}

                        <TableRow>
                          <TableCell align="left">
                            <Box
                              sx={{
                                width: "400px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: "1",
                                WebkitBoxOrient: "vertical",
                              }}
                            >
                              Kerry Deely
                            </Box>
                          </TableCell>
                          <TableCell align="left"></TableCell>
                          <TableCell align="left"></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="left">
                            <Box
                              sx={{
                                width: "400px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: "1",
                                WebkitBoxOrient: "vertical",
                              }}
                            >
                              Jonathan Evans
                            </Box>
                          </TableCell>
                          <TableCell align="left"></TableCell>
                          <TableCell align="left"></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="left">
                            <Box
                              sx={{
                                width: "400px",
                                textTransform: "uppercase",
                                fontWeight: "bold",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: "1",
                                WebkitBoxOrient: "vertical",
                              }}
                            >
                              Don Mead
                            </Box>
                          </TableCell>
                          <TableCell align="left"></TableCell>
                          <TableCell align="left"></TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </>
    );
};

export default PrintWeeklyTimeSummariesButton;
